import { INVALID_EMAIL, INVALID_PASSWORD } from 'features/auth/ducks/types';

export const AUTH_ERRORS = {
  'auth/wrong-password': {
    type: INVALID_PASSWORD,
    message: 'Incorrect Password'
  },
  'auth/user-not-found': {
    type: INVALID_EMAIL,
    message: 'Email address not found'
  },
  'auth/user-disabled': {
    type: INVALID_EMAIL,
    message: 'Account Deactivated'
  }
};

export const WRONG_PASSWORD = 'auth/wrong-password';
export const TOO_MANY_REQUESTS = 'auth/too-many-requests';

export const REQUIRED_ERROR_MSG = 'This field is required';

export const USER_NOT_SIGNED_IN_ERROR_MSG = 'user is not signed in!';

export const WORKOUT_NAME_MUST_BE_UNIQUE = 'Workout Name must be unique!';

export const PLAN_NAME_MUST_BE_UNIQUE = 'Plan Name must be unique!';

export const SERIES_CREATION_AT_LEAST_ONE_EXERCISE =
  'You should submit at least on exercise';

export const SERIES_NAME_MUST_BE_UNIQUE = 'Series Name must be unique!';

export const EXERCISE_UNIQUENESS_ERROR = 'Exercise Name must be unique!';

export const POSITIVE_NUMBER_ERROR_MSG =
  'This field must be a positive number!';

export const UNVERIFIED_EMAIL = 'Email address is not verified!';

export const RESET_PASSWORD_ERROR =
  'Something went wrong, Please enter valid trainer email!';

export const SIGN_IN_LINK_ERROR = 'invalid sign in link!';
